import React, { Component } from "react";
import "./Landing.css";
import Colors from "../../constants/Colors";
import firebase from "../../firebase/firebase";
import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemButton,
    AccordionItemPanel,
} from 'react-accessible-accordion';

// Demo styles, see 'Styles' section below for some notes on use.
import 'react-accessible-accordion/dist/fancy-example.css';

interface IState {
  status: "success" | "error" | "";

  isLoading: boolean;

  email: string;
  topic: string;
  message: string;
}

type Props = {};

export default class Landing extends Component<Props> {
  state: Readonly<IState> = {
    status: "",

    isLoading: false,

    email: "",
    topic: "",
    message: "",
  };

  onSend() {
    const { email, topic, message } = this.state;
    this.setState({
      isLoading: true,
    });

    if (!email || !topic || !message) {
      this.setState({
        isLoading: false,
      });

      return;
    }

    const sendContactSupportMail = firebase
      .functions()
      .httpsCallable("sendContactSupportMail");

    sendContactSupportMail({ email: email, topic: topic, message: message } as {
      email: string;
      topic: string;
      message: string;
    })
      .then((result) => {
        this.setState({
          status: "",

          email: "",
          topic: "",
          message: "",
        });
      })
      .catch((e) => {
        this.setState({
          status: "error",
        });
      });

    this.setState({
      isLoading: false,
    });
  }

  render() {
    return (
      <div className={"landingContainer"}>
          <h1>acami Support</h1>

          <h2>Hast du eines der folgenden Probleme?</h2>

          <Accordion>
              <AccordionItem>
                  <AccordionItemHeading>
                      <AccordionItemButton>
                          Alte Daten nach neuem anmelden weg?
                      </AccordionItemButton>
                  </AccordionItemHeading>
                  <AccordionItemPanel>
                      <p>
                          Dies liegt wahrscheinlich daran, dass du deinen Account über eine andere Anmeldemethode erstellt hast.
                          Logge dich aus und nehme die Anmeldemethode, mit der du dich zum ersten mal registriert hast.
                      </p>
                  </AccordionItemPanel>
              </AccordionItem>
              <AccordionItem>
                  <AccordionItemHeading>
                      <AccordionItemButton>
                          Die App ist zu groß?
                      </AccordionItemButton>
                  </AccordionItemHeading>
                  <AccordionItemPanel>
                      <p>
                          Wir Cachen Daten, damit die App schneller lädt, weniger Daten verbraucht und flüssiger funktioniert.
                          Dies bedeutet aber auch, dass wir Daten lokal auf deinem gerät zwischen speichern, was wiederum
                          dazu führen kann, dass dein freier Speicher auf deinem Gerät kleiner wird. Falls du wieder
                          mehr speicher brauchst, kannst du den Cache einfach in den Einstellungen leeren.
                      </p>
                  </AccordionItemPanel>
              </AccordionItem>
              <AccordionItem>
                  <AccordionItemHeading>
                      <AccordionItemButton>
                          Die Bilder laden nicht?
                      </AccordionItemButton>
                  </AccordionItemHeading>
                  <AccordionItemPanel>
                      <p>
                          Dies kann mehrere Gründe haben. Zu aller erst solltest du prüfen, ob du Internet hast.
                          Wenn dies der Fall ist, leere in den Einstellungen den Cache und starte die App neu.
                          Falls die Bilder immer noch nicht laden, bleibt als letzter Schritt, dass du dich
                          einmal ausloggst und dich neu anmeldest.
                      </p>
                  </AccordionItemPanel>
              </AccordionItem>
              <AccordionItem>
                  <AccordionItemHeading>
                      <AccordionItemButton>
                          Die App ist während der Benutzung abgestürzt?
                      </AccordionItemButton>
                  </AccordionItemHeading>
                  <AccordionItemPanel>
                      <p>
                          acami wurde von einem kleinen Team entwickelt, daher kann es leider teilweise passieren,
                          dass einige Funktionen noch nicht komplett erfüllt werden oder es sogar zu abstürzen kommen kann.
                          Wenn dir so etwas aufgefallen ist, schreibe uns bitte im unteren Kontaktfeld, was du gemacht hast,
                          bevor der Fehler aufgetreten ist, damit wir dies so schnell wie möglich beheben können.
                      </p>
                  </AccordionItemPanel>
              </AccordionItem>
          </Accordion>


        <h2 style={{marginTop: 60}}>acami Support kontaktieren:</h2>
        <h3>
          Hast Du Probleme mit der App oder willst uns einfach nur Feedback
          geben, dann kannst du uns eine E-Mail an:{" "}
          <a
            href={"mailto:support@meeter.de"}
            style={{ color: Colors.mainColor, textDecoration: "underline" }}
          >
            support@meeter.de
          </a>{" "}
          schreiben oder schreibe uns direkt hier:
        </h3>

        {this.state.status === "error" && (
          <h3 color={Colors.mainColor} style={{ color: Colors.mainColor }}>
            Es gab ein Problem. Probier es später nochmal
          </h3>
        )}

        <input
          type={"email"}
          placeholder={"Deine E-Mail"}
          value={this.state.email}
          onChange={(event) =>
            this.setState({
              email: event.target.value,
            })
          }
        />

        <input
          type={"text"}
          placeholder={"Grund der Support Nachricht"}
          value={this.state.topic}
          onChange={(event) =>
            this.setState({
              topic: event.target.value,
            })
          }
        />

        <textarea
          placeholder={"Deine Nachricht"}
          value={this.state.message}
          onChange={(event) =>
            this.setState({
              message: event.target.value,
            })
          }
        />

        {!this.state.isLoading && (
          <a onClick={() => this.onSend()} className={"button"}>
            Absenden
          </a>
        )}

        {this.state.isLoading && <a className={"button"}>Senden...</a>}
      </div>
    );
  }
}
